import React, { useState, useEffect } from 'react';
import TextLoop from 'react-text-loop';
import { map, reduce, filter, isNil, isEmpty } from 'lodash';
import useInterval from '../../hooks/useInterval';
import expirationStorageService from '../../common/expirationStorageService';
import { get } from '../../common/httpService';
import common from '../../common/common';
import setCustomStyle from './infobox';
import InfoboxGroup from './InfoboxGroup.jsx';
import InfoboxSecondary from './InfoboxSecondary.jsx';

import './Infobox.scss';

const Infoboxes = () => {
    const INFOBOX_MESSAGE_CLOSED = 'INFOBOX_MESSAGE_CLOSED';
    const CHECK_ELEMENTS_DURATION = 10000; // 10s DURATION for SECONDARY ELEMENTS

    const [primary, setPrimary] = useState([]);
    const [secondary, setSecondary] = useState([]);
    const [secondaryVisible, setSecondaryVisible] = useState([]);

    expirationStorageService.init(INFOBOX_MESSAGE_CLOSED);

    const rotateElements = (arr) => {
        const elementToRotate = arr.slice(0, 1);
        const result = [...arr.slice(1, arr.length), ...elementToRotate];
        return result;
    };

    const setSecondaryVisibleWithoutRemoved = (all) => {
        const expiredElements = expirationStorageService.get({
            key: INFOBOX_MESSAGE_CLOSED,
        });
        if (expiredElements !== undefined) {
            const allNotExpired = reduce(
                all,
                (acc, el) => {
                    const expiredInfos = map(expiredElements, (e) => e.info);
                    if (!expiredInfos.includes(el.info)) {
                        acc.push(el);
                    }
                    return acc;
                },
                []
            );
            setSecondaryVisible(allNotExpired);
        } else {
            if (secondaryVisible.length === 0 && secondary.length === 0) {
                setSecondaryVisible(all);
                return;
            }
            if (
                secondaryVisible.length !== secondary.length &&
                secondary.length > 0
            ) {
                setSecondaryVisible(secondary);
                return;
            } else {
                const x = rotateElements(secondaryVisible);

                setSecondaryVisible(x);
            }
        }
    };
    const fetchData = async () => {
        let primary = [];
        let secondary = [];
        try {
            const data = await get({
                url: `infobox/infos`,
            });

            const createHeaderMessages = function (headerData) {
                const today = new Date();
                const yesterday = new Date(today);
                yesterday.setDate(yesterday.getDate() - 1);
                const oneYearInTheFuture = new Date(today);
                oneYearInTheFuture.setDate(today.getDate() + 365);
                let res = [];
                if (headerData.standardMessage === false) {
                    res.push({
                        validFrom: yesterday,
                        validTo: oneYearInTheFuture,
                        info: `<div class="header_messages_container"><div class="text-center"><a class="message__link" href="${
                            headerData.freeShippingUrl
                        }" style="text-decoration: none; border-bottom: none;"><img class="infobox-freeshipping-icon" src="${common.contentFromCdn(
                            {
                                path: '/Content/img/free-shipping.svg',
                                keepUrlAsIs: false,
                            }
                        )}" /><strong>${
                            headerData.freeShippingMessageLinkText
                        } </strong></a><a class="message__link" href="${
                            headerData.freeShippingUrl
                        }">${headerData.freeShippingMessage}</div></div>`,
                        color: '',
                        backgroundColor: '',
                    });
                }
                res.push({
                    validFrom: yesterday,
                    validTo: oneYearInTheFuture,
                    info: `<div class="header_messages_container"><div class="text-center"><a class="message__link" href="${
                        headerData.fastShippingUrl
                    }" style="text-decoration: none; border-bottom: none;"><img  class="infobox-fastshipping-icon" src="${common.contentFromCdn(
                        {
                            path: '/Content/img/fast-delivery.svg',
                            keepUrlAsIs: false,
                        }
                    )}" /> <strong>${
                        headerData.fastShippingMessageLinkText
                    } </strong></a><a class="message__link" href="${
                        headerData.fastShippingUrl
                    }">${headerData.fastShippingMessage}</div></div>`,
                    color: '',
                    backgroundColor: '',
                });
                res.push({
                    validFrom: yesterday,
                    validTo: oneYearInTheFuture,
                    info: `<div class="header_messages_container"><div class="text-center"><a class="message__link" href="${
                        headerData.securePaymentsUrl
                    }" style="text-decoration: none; border-bottom: none;"><img  class="infobox-securepayments-icon" src="${common.contentFromCdn(
                        {
                            path: '/Content/img/secure-payments.svg',
                            keepUrlAsIs: false,
                        }
                    )}" /><strong>${
                        headerData.securePaymentsMessageLinkText
                    } </strong></a><a class="message__link" href="${
                        headerData.securePaymentsUrl
                    }">${headerData.securePaymentsMessage}</div></div>`,
                    color: '',
                    backgroundColor: '',
                });
                return res;
            };

            if (!isNil(data.infos)) {
                const headerMessages = createHeaderMessages(
                    data.headerMessages
                );
                const infosForCulture = data.infos.filter((i) => i !== null);

                const result = filter(infosForCulture, (i) => !isNil(i.info));

                primary = headerMessages.concat(
                    filter(
                        map(result, (item, index) => {
                            return {
                                validFrom: item.validFrom,
                                validTo: item.validTo,
                                info: item.info || '',
                                color: item.colorInfo || '',
                                backgroundColor: item.backgroundColorInfo || '',
                            };
                        }),
                        (i) => !isEmpty(i.info)
                    )
                );
                secondary = filter(
                    map(
                        result,
                        (item, index) => {
                            return {
                                validFrom: item.validFrom,
                                validTo: item.validTo,
                                info: item.infoSecondary || '',
                                countdownTitle: item.countdownTitle || '',
                                color: item.colorInfoSecondary || '',
                                backgroundColor:
                                    item.backgroundColorInfoSecondary || '',
                                destinations: item.destinations || [],
                            };
                        },
                        []
                    ),
                    (e) => !isEmpty(e.info)
                );
            }
        } catch (error) {
            if (error.status !== 404) {
                console.error('error.status', error.status);
                console.error('Error retrieving infobox data', error);
            }
        }

        return [primary, secondary];
    };

    useEffect(() => {
        async function fetchAll() {
            const [primary, secondary] = await fetchData();
            setPrimary(primary);
            setSecondary(secondary);
            setSecondaryVisibleWithoutRemoved(secondary);
        }
        fetchAll();
    }, []);

    useInterval(
        () => setSecondaryVisibleWithoutRemoved(secondary),
        CHECK_ELEMENTS_DURATION
    );

    function closeBanner(item) {
        const result = reduce(
            secondaryVisible,
            (acc, i, index) => {
                if (i.info !== item.info) {
                    acc.push(i);
                }
                return acc;
            },
            []
        );
        setSecondaryVisible(result);
        expirationStorageService.add({
            key: INFOBOX_MESSAGE_CLOSED,
            data: item,
        });
    }

    const infosPrimary = map(
        primary,
        (item, index) => {
            if (item && item.info !== '') {
                let customStyle = setCustomStyle(item);
                return (
                    <div
                        key={index}
                        style={{ maxWidth: document.body.clientWidth + 'px' }}>
                        <span className='ticker__item' style={customStyle}>
                            <span
                                dangerouslySetInnerHTML={{ __html: item.info }}
                                style={{
                                    maxWidth: document.body.clientWidth + 'px',
                                }}></span>
                        </span>
                    </div>
                );
            }
            return <div key={index}></div>;
        },
        []
    );

    return (
        <div className='ticker-wrap'>
            <div
                className='ticker'
                style={{ maxWidth: document.body.clientWidth + 'px' }}>
                {primary.length > 0 ? (
                    <TextLoop
                        interval='12000'
                        noWrap={true}
                        springConfig={{ stiffness: 210, damping: 20 }}
                        fade={true}
                        mask={true}
                        style={{ maxWidth: document.body.clientWidth + 'px' }}>
                        {infosPrimary}
                    </TextLoop>
                ) : (
                    <div style={{ height: 0 }} />
                )}
            </div>
            {secondaryVisible && secondaryVisible.length > 0 ? (
                <InfoboxGroup>
                    <div className='ticker'>
                        <InfoboxSecondary
                            secondaryVisible={secondaryVisible[0]}
                            closeBanner={closeBanner}
                        />
                    </div>
                </InfoboxGroup>
            ) : (
                <div style={{ height: 0 }} />
            )}
        </div>
    );
};

export default Infoboxes;
